<template>
  <div>
    <h3>{{ $t('account-title-my-details') }}</h3>
    <b-form @submit.prevent="updateSub">
      <b-row>
        <b-col sm="12" lg="10">
          <b-row>
            <b-col cols="12" class="pb-3">
              <label>
                {{ $t('firstname') }}
                <span class="text-danger">*</span>
              </label>
              <b-form-input v-model="form.firstname" required></b-form-input>
            </b-col>
            <b-col cols="12" class="pb-3">
              <label>
                {{ $t('lastname') }}
                <span class="text-danger">*</span>
              </label>
              <b-form-input v-model="form.lastname" required></b-form-input>
            </b-col>
            <b-col cols="12" class="pb-3">
              <label>
                {{ $t('emailaddress') }}
                <span class="text-danger">*</span>
              </label>
              <b-form-input v-model="form.email" required></b-form-input>
            </b-col>
            <b-col cols="12">
              <label>
                {{ $t('gsm') }}
                <span class="text-danger">*</span>
              </label>
              <b-form-input
                v-model="form.MobilePhone"
                oninput="javascript: this.value = this.value.replace(/[A-Za-z]/gi, '');"
                required
              ></b-form-input>
            </b-col>
            <b-col>
              <b-form-checkbox
                id="receive-newsletter"
                v-model="form.CUST_ReceiveNewsletter"
                name="receive-newsletter"
                value="accepted"
                unchecked-value="not_accepted"
                class="mt-3"
              >
                {{ $t('receive-newsletter') }}
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="text-right mt-3">
              <b-button variant="primary" type="submit">
                {{ $t('save-changes') }}
                <font-awesome-icon
                  v-if="processing"
                  :icon="['fad', 'spinner']"
                  class="fa-spin"
                  far
                />
              </b-button>
              <hr />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <change-password />
  </div>
</template>
<script>
import { modifySub, getSubs } from '@/services/AuthorizationService'
import ChangePassword from './ChangePassword'
export default {
  components: {
    'change-password': ChangePassword
  },
  props: {
    user: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        username: '',
        firstname: '',
        lastname: '',
        tel: '',
        MobilePhone: '',
        password: '',
        passwordConfirm: '',
        CUST_ReceiveNewsletter: false
      },
      subUser: null,
      processing: false
    }
  },
  computed: {
    subUsers: function() {
      return this.$store.getters.subUsers
    }
  },
  created: async function() {
    await getSubs()
    this.form.username = this.user.UserName
    this.form.firstname = this.user.FirstName
    this.form.lastname = this.user.LastName
    this.form.tel = this.user.Tel
    this.form.MobilePhone = this.user.MobilePhone
    this.form.email = this.user.Email
    this.subUser = this.subUsers.find(obj => {
      return obj.UserName === this.$store.getters.account.UserEmail
    })

    this.form = {
      email: this.subUser.Email || '',
      street: this.subUser.CUST_Street,
      city: this.subUser.CUST_City,
      houseNumber: this.subUser.CUST_HouseNumber,
      postcode: this.subUser.CUST_ZipCode,
      tel: this.subUser.Tel,
      firstname: this.subUser.FirstName,
      lastname: this.subUser.LastName,
      MobilePhone: this.subUser.MobilePhone,
      CUST_ReceiveNewsletter: this.$store.getters.account.CUST_ReceiveNewsletter
        ? 'accepted'
        : 'declined'
    }
  },
  methods: {
    notify({ message }) {
      this.$toasted.show(message)
    },
    updateSub: async function() {
      this.processing = true
      // if (Object.values(this.form).some(x => x !== null && x !== '')) {
      //   alert('not all fields are filled')
      // }
      const result = await modifySub({
        email: this.form.email || '',
        password: this.form.password,
        confirmPassword: this.form.confirmPassword,
        street: this.form.street,
        city: this.form.city,
        houseNumber: this.form.houseNumber,
        postcode: this.form.postcode,
        firstname: this.form.firstname,
        lastname: this.form.lastname,
        contactID: this.subUser.ContactID,
        userName: this.subUser.UserName,
        tel: this.form.tel,
        MobilePhone: this.form.MobilePhone,
        CUST_ReceiveNewsletter: this.form.CUST_ReceiveNewsletter === 'accepted'
      })

      if (result !== null)
        this.notify({ message: this.$t('information-succesfully-modified') })
      this.processing = false
    }
  }
}
</script>
